import { createFileRoute } from "@tanstack/react-router";
import { DictionaryEditor } from "../../components/DictionaryEditor";
import type { DictationMethod } from "../../stores/settings-store";
import { useSettingsStore } from "../../stores/settings-store";

export const Route = createFileRoute("/_app/settings")({
  component: SettingsPage,
});

const dictationMethodOptions: Array<{
  value: DictationMethod;
  label: string;
  description: string;
}> = [
  {
    value: "text",
    label: "文字ベース",
    description:
      "音声認識で得たテキストを AI でひらがなに整形します。速く、認識済みの読みをそのまま使います。",
  },
  {
    value: "audio",
    label: "音声ベース",
    description:
      "録音した音声を AI が直接聞き取って書き起こします。少し時間がかかり、まれに読みが揺れることがあります。",
  },
];

function SettingsPage() {
  const dictationMethod = useSettingsStore((s) => s.dictationMethod);
  const setDictationMethod = useSettingsStore((s) => s.setDictationMethod);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">設定</h1>
        <p className="text-sm text-neutral-600 mt-1">
          アプリ全体の設定です。この端末に保存されます。
        </p>
      </div>

      <section className="space-y-3">
        <h2 className="font-semibold">書き起こしモードの方式</h2>
        <div className="space-y-2">
          {dictationMethodOptions.map((opt) => (
            <label
              key={opt.value}
              className={`flex items-start gap-3 rounded-xl border p-4 cursor-pointer transition-colors ${
                dictationMethod === opt.value
                  ? "border-neutral-900 bg-neutral-50"
                  : "border-neutral-200 bg-white hover:border-neutral-400"
              }`}
            >
              <input
                type="radio"
                name="dictationMethod"
                checked={dictationMethod === opt.value}
                onChange={() => setDictationMethod(opt.value)}
                className="mt-1"
              />
              <div>
                <div className="font-semibold">{opt.label}</div>
                <div className="text-sm text-neutral-600 mt-1">
                  {opt.description}
                </div>
              </div>
            </label>
          ))}
        </div>
      </section>

      <DictionaryEditor />
    </div>
  );
}
